import React from 'react';
import { createRoot } from 'react-dom/client'; // Mettez à jour l'importation
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from "@react-oauth/google"
import { register } from './utils/serviceWorker';
import { LoadingProvider } from './context/LoadingProvider';
import { NotificationProvider } from './context/NotificationProvider';
import i18n from './i18n';

const SEO_META = {
  fr: {
    title: 'flyspa Booking - Réserver en ligne votre massage professionnel',
    description:
      'Massage à booker en ligne, à domicile, hôtel, bureau ou dans un hôtel partenaire au plus tôt dans une heure, sur tout l’arc lémanique',
  },
  en: {
    title: 'flyspa Booking - Book your professional massage online',
    description:
      'Massage to be booked online, at home, hotel, office, or in a partner hotel within an hour at the earliest, throughout the Lake Geneva region',
  },
};

const applyHtmlLang = (lng) => {
  if (lng) {
    document.documentElement.setAttribute('lang', lng);
  }
};

const applySeoMeta = (lng) => {
  const meta = SEO_META[lng] || SEO_META.fr;
  if (!meta) return;

  document.title = meta.title;

  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute('content', meta.description);
  }
};

const applyLanguageSideEffects = (lng) => {
  applyHtmlLang(lng);
  applySeoMeta(lng);
};

const localeMatch = window.location.pathname.match(/^\/(en|fr)(\/|$)/i);

if (localeMatch) {
  const locale = localeMatch[1].toLowerCase();
  const newPath = window.location.pathname.replace(/^\/(en|fr)/i, "") || "/";
  const newUrl = `${newPath}${window.location.search}${window.location.hash}`;

  i18n.changeLanguage(locale);
  localStorage.setItem("i18nextLng", locale);
  applyLanguageSideEffects(locale);
  window.history.replaceState({}, "", newUrl);
}

i18n.on('languageChanged', applyLanguageSideEffects);
applyLanguageSideEffects(i18n.resolvedLanguage || i18n.language);

// Utilisez createRoot pour rendre votre application
const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Routes>
          <Route path="/*" element={<LoadingProvider><NotificationProvider><App /></NotificationProvider></LoadingProvider>} />
        </Routes>
      </GoogleOAuthProvider>
    </AuthProvider>
  </BrowserRouter>
);
register();
